/* 🤖 this file was generated by svg-to-ts */
export const matIconDeveloperBoardOff: {
  name: 'developer-board-off';
  data: string;
} = {
  name: 'developer-board-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.83 5H18v10.17L19.83 17H22v-2h-2v-2h2v-2h-2V9h2V7h-2V5c0-1.1-.9-2-2-2H5.83l2 2zM12 9.17V7h4v3h-3.17L12 9.17zM9.83 7H11v1.17L9.83 7zm4 4H16v2.17L13.83 11zM18 21c.06 0 .11 0 .16-.01l2.32 2.32 1.41-1.41L2.1 2.1.69 3.51l1.32 1.32C2 4.89 2 4.94 2 5v14c0 1.1.9 2 2 2h14zM4 19V6.83l2 2V12h3.17l1 1H6v4h5v-3.17l1 1V17h2.17l2 2H4z"/></svg>`
};
